var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["quickshop-actions/quickshop-add-link-outer.j2"] = require( "quickshop-actions/quickshop-add-link-outer.j2" );
dependencies["quickshop-actions/quickshop-wishlist-move-outer.j2"] = require( "quickshop-actions/quickshop-wishlist-move-outer.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-add-to-cart.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<div class=\"dom-add-to-cart\">";
var t_1;
t_1 = {"addToCart": "product_add-to-cart","addedToCart": "product_added-to-cart","addingToCart": "product_adding-to-cart"};
frame.set("SLAs", t_1, true);
if(frame.topLevel) {
context.setVariable("SLAs", t_1);
}
if(frame.topLevel) {
context.addExport("SLAs", t_1);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"showAddToCart")) {
output += "\n    ";
output += "\n\n    <ul class=\"c-product-add-link\">\n\n        ";
env.getTemplate("quickshop-actions/quickshop-add-link-outer.j2", false, "product/templates/product-add-to-cart.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "wishlist") {
output += "\n            ";
env.getTemplate("quickshop-actions/quickshop-wishlist-move-outer.j2", false, "product/templates/product-add-to-cart.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n        ";
})});
}
output += "\n    </ul>\n\n";
})});
}
else {
output += "\n\n    ";
var t_10;
t_10 = (lineno = 21, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productAddToCart.addToCartReady",false]));
frame.set("addToCartReady", t_10, true);
if(frame.topLevel) {
context.setVariable("addToCartReady", t_10);
}
if(frame.topLevel) {
context.addExport("addToCartReady", t_10);
}
var t_11;
t_11 = (!runtime.contextOrFrameLookup(context, frame, "addToCartReady") && !runtime.contextOrFrameLookup(context, frame, "quickshop")) || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"canAddToCart"));
frame.set("disableAddToCart", t_11, true);
if(frame.topLevel) {
context.setVariable("disableAddToCart", t_11);
}
if(frame.topLevel) {
context.addExport("disableAddToCart", t_11);
}
if(runtime.contextOrFrameLookup(context, frame, "disableAddToCart")) {
var t_12;
t_12 = "disabled";
frame.set("disabled", t_12, true);
if(frame.topLevel) {
context.setVariable("disabled", t_12);
}
if(frame.topLevel) {
context.addExport("disabled", t_12);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_13;
t_13 = "";
frame.set("disabled", t_13, true);
if(frame.topLevel) {
context.setVariable("disabled", t_13);
}
if(frame.topLevel) {
context.addExport("disabled", t_13);
}
output += "\n    ";
;
}
output += "\n\n    <div class=\"c-form__field";
if(runtime.contextOrFrameLookup(context, frame, "disableAddToCart")) {
output += " is-disabled";
;
}
output += "\">\n\n        <button type=\"submit\" ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabled"), env.opts.autoescape);
output += "\n                class=\"js-add-to-cart o-button-basket c-product-add-to-cart__button";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isPending")) {
output += " is-pending";
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isSuccess")) {
output += " is-confirmed data-qa-added-to-cart";
;
}
output += "\"\n                aria-controls=\"a-cart-confirm\"\n                data-qa-add-to-cart\n                data-cm-element=\"add_to_cart\"\n                data-product-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"id"), env.opts.autoescape);
output += "\"";
if(runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "\n                    data-product-type=\"family\"\n                ";
;
}
else {
output += "\n                    data-product-type=\"regular\"\n                ";
;
}
output += ">\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isPending") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isSuccess")) {
output += "<span class=\"c-product-add-to-cart__text c-product-add-to-cart__text--loading\" data-qa-add-to-cart-text>\n                    <span class=\"c-product-add-to-cart__circle\"></span>\n                    <span class=\"c-product-add-to-cart__circle\"></span>\n                    <span class=\"c-product-add-to-cart__circle\"></span>\n                </span>\n\n            ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isSuccess") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isPending")) {
output += "<span class=\"c-product-add-to-cart__text\" data-qa-add-to-cart-text>\n                    ";
output += runtime.suppressValue((lineno = 69, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "SLAs")),"addedToCart")])), env.opts.autoescape);
output += "\n                </span>\n\n            ";
;
}
else {
output += "<span class=\"c-product-add-to-cart__text\" data-qa-add-to-cart-text>\n                    ";
output += runtime.suppressValue((lineno = 76, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "SLAs")),"addToCart")])), env.opts.autoescape);
output += "\n                </span>";
;
}
;
}
output += "\n\n        </button>\n\n    </div>\n\n";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-add-to-cart.j2"] , dependencies)